import { useEffect, useState } from 'react';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { GameController, ArrowRight } from '@phosphor-icons/react';
import { DashboardPreview } from '../DashboardPreview';

const STAT_LABELS = [
  { key: 'players', label: 'Registered Players' },
  { key: 'games', label: 'Games Listed' },
  { key: 'rooms', label: 'Rooms Created' },
];

const useLiveStats = () => {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/public/stats`).then((r) => setStats(r.data)).catch(() => setStats(null));
  }, []);
  return stats;
};

export const HeroSection = ({ onGetStarted }) => {
  const stats = useLiveStats();
  return (
    <section className="pt-32 pb-20 px-6 bg-gradient-to-b from-[#FAFAFA] to-white">
      <div className="max-w-7xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#0047FF]/10 text-[#0047FF] text-sm font-medium mb-6">
          <GameController size={18} weight="fill" />
          The Ultimate Gaming Hub
        </div>
        
        <h1 className="font-heading text-5xl md:text-7xl font-bold tracking-tight text-[#09090B] mb-6">
          Level Up Your Game
        </h1>
        
        <p className="text-lg md:text-xl text-[#71717A] max-w-2xl mx-auto mb-10">
          Connect with gamers worldwide, watch live streams, climb the leaderboards, 
          and become part of the ultimate gaming community.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button 
            size="lg"
            onClick={onGetStarted}
            className="bg-[#0047FF] hover:bg-[#0037CC] text-white text-lg px-8 py-6 transition-transform hover:-translate-y-1"
            data-testid="hero-get-started"
          >
            Get Started Free
            <ArrowRight size={20} className="ml-2" />
          </Button>
          <Button 
            size="lg"
            variant="outline"
            onClick={() => document.getElementById('features').scrollIntoView({ behavior: 'smooth' })}
            className="border-[#E4E4E7] text-[#09090B] text-lg px-8 py-6"
          >
            Learn More
          </Button>
        </div>

        <div className="mt-16 relative">
          <div className="max-w-5xl mx-auto">
            <p className="mb-3 text-xs font-mono uppercase tracking-widest text-[#71717A]" data-testid="preview-sample-label">Product preview · sample data</p>
            <DashboardPreview />
            <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 flex gap-4" data-testid="hero-live-stats">
              {stats && STAT_LABELS.filter((s) => stats[s.key] > 0).map((stat) => (
                <div key={stat.key} className="bg-white px-6 py-4 shadow-lg border border-[#E4E4E7]">
                  <p className="font-mono text-2xl font-bold text-[#0047FF]" data-testid={`hero-stat-${stat.key}`}>
                    {Number(stats[stat.key] || 0).toLocaleString()}
                  </p>
                  <p className="text-xs text-[#71717A]">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
